



















import { defineComponent, onBeforeUnmount, PropType, ref, toRef, watch } from "@vue/composition-api";
import { UserPublicData } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import { getMessageUrl } from "@/lib/urlHelpers";
import BaseAvatar from "@/components/BaseAvatar";
import BaseButton from "@/components/BaseButton";

export default defineComponent({
  name: "AppointmentReminderView",
  components: { BaseAvatar, BaseButton },
  props: {
    show: { type: Boolean, required: true },
    startTime: { type: Number as PropType<number | null> },
    user: { type: Object as PropType<UserPublicData | null> },
    isOffline: { type: Boolean, default: false },
  },
  setup(props) {
    const countdown = ref(0);
    const timer = ref<NodeJS.Timeout>();

    const getRemindMinutes = () => {
      if (!props.startTime) return;
      if (props.startTime - Date.now() < 0) {
        timer.value && clearInterval(timer.value);
        countdown.value = 0;
        return;
      }
      countdown.value = new Date(props.startTime - Date.now()).getMinutes() + 1;
    };

    const startCountdown = () => {
      if (timer.value) {
        clearInterval(timer.value);
      }
      if (!props.startTime) return;
      getRemindMinutes();
      timer.value = setInterval(getRemindMinutes, 10000);
    };

    watch(toRef(props, "startTime"), () => {
      startCountdown();
    });
    watch(
      toRef(props, "show"),
      show => {
        const root = document.documentElement;
        root.style.setProperty("--safe-bottom-position-appointment", show ? "57px" : "0px");
      },
      { immediate: true }
    );

    startCountdown();
    onBeforeUnmount(() => {
      timer.value && clearInterval(timer.value);
    });
    return {
      countdown,
      getMessageUrl,
    };
  },
});
